import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/home/home'
import SoundSafe from '@/components/pages/solution/SoundSafe'
import SoundDetect from '@/components/pages/solution/Hs/SoundDetect'
import SoundScriber from '@/components/pages/solution/Hs/SoundScriber'
import SoundDenoise from '@/components/pages/solution/Rs/SoundDenoise'
import SoundCapture from '@/components/pages/solution/Sj/SoundCapture'
import SoundMeeting from '@/components/pages/solution/Hs/SoundMeeting'
import Solution from '@/components/pages/solution/solution'
import coreTechnology from '@/components/pages/coreTechnology/coreTechnology'
import experienceCenter from '@/components/pages/form/experienceCenter'
import aboutus from '@/components/pages/aboutus/aboutus'
import joinus from '@/components/pages/aboutus/joinus/joinus'
import introduction from '@/components/pages//aboutus/introdution/introduction'

Vue.use(Router)

export default new Router({
  // linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: '/home',
      children: [],
      meta: {
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        active: 'Home'
      },
      children: []
    },
    {
      path: '/solution',
      name: Solution,
      redirect: '/solution/SoundGuard',
      component: Solution,
      children: [
        {
          path: 'SoundGuard',
          name: 'SoundSafe',
          component: SoundSafe,
          meta: {
            active: 'Solution',
            title: '大晟极-远程身份认证'
          },
          children: []
        },
        {
          path: 'SoundDetect',
          name: 'SoundDetect',
          component: SoundDetect,
          meta: {
            active: 'Solution',
            title: '大晟极-声纹库及搜索比对系统'
          },
          children: []
        },
        {
          path: 'SoundDenoise',
          name: 'SoundDenoise',
          component: SoundDenoise,
          meta: {
            active: 'Solution',
            title: '大晟极-语音降噪与增强系统'
          },
          children: []
        }, {
          path: 'SoundScriber',
          name: 'SoundScriber',
          component: SoundScriber,
          meta: {
            active: 'Solution',
            title: '大晟极-音频数据智能分析系统'
          },
          children: []
        },
        {
          path: 'SoundCapture',
          name: 'SoundCapture',
          component: SoundCapture,
          meta: {
            active: 'Solution',
            title: '大晟极-语音采集工作站'
          },
          children: []
        },
        {
          path: 'SoundMeeting',
          name: 'SoundMeeting',
          component: SoundMeeting,
          meta: {
            active: 'Solution',
            title: '大晟极-多模态智能会议协作系统'
          },
          children: []
        }
      ]
    },
    {
      path: '/coreTechnology',
      name: 'coreTechnology',
      component: coreTechnology,
      meta: {
        active: 'coreTechnology'
      },
      children: []
    },
    {
      path: '/experienceCenter',
      name: 'experienceCenter',
      component: experienceCenter,
      meta: {
        active: 'experienceCenter'
      },
      children: []
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus,
      redirect: '/aboutus/joinus',
      meta: {
        active: 'aboutus'
      },
      children: [
        {
          path: 'joinus',
          name: 'joinus',
          component: joinus,
          meta: {
            active: 'aboutus'
          },
          children: []
        },
        {
          path: 'introduction',
          name: 'introduction',
          component: introduction,
          meta: {
            active: 'aboutus'
          },
          children: []
        }
      ]
    },
    {
      // 会匹配所有路径
      path: '*',
      redirect: '/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js